(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvDialogHeader', drvDialogHeader);
    
    function drvDialogHeader() {
        var directive = {
            restrict: 'E',
            scope: {
                titleText: '<?',
                titleIconUsage: '<?',
                titleIcon: '<?',
                titleIconColour: '<?',
                closeOnClick: '&?',
                hideClose: '<?'
            },
            transclude: true,
            replace: true,
            template:
                '<div class="modal-header">' +
                '   <div class="title-bar" layout="row" layout-align="left center">' +
                '       <drv-icon ng-if="titleIcon || titleIconUsage" usage="titleIconUsage" icon="titleIcon" colour="titleIconColour" style="margin-right: 8px;"></drv-icon>' +
                '       <h1 flex="grow">{{titleText}}</h1>' +
                '       <div flex="nogrow" ng-if="!hideClose">' +
                '           <md-button aria-label="Close" ng-click="closeOnClick()" class="md-icon-button" style="padding: 4px;">' +
                '               <drv-icon usage="\'close\'" colour="\'rgb(128,128,128)\'"></drv-icon>' +
                '           </md-button>' +
                '       </div>' +
                '   </div>' +
                '  <ng-transclude></ng-transclude>' +
                '</div>'
        };
        return directive;
    }
})();